const regExp = RegExp(/\S+@\S+\.\S+/)

export const isEmailValid = email => {
  return regExp.test(email)
}
